import React from "react";
import { isMobile } from "react-device-detect";

import Contact from "../components/Contact";

function ContactPage(props) {
    return (
        <div className="h-full flex flex-col lg:flex-row ">
            <div className="relative flex flex-col py-10 px-3 gap-4 text-center h-1/2 lg:h-full lg:w-1/2 justify-center sm:text-xl">
                <div>
                    <div className="text-xl sm:text-3xl font-fredoka mb-2">
                        Location
                    </div>
                    <div>525 Everhart Rd #2, </div>
                    <div>Corpus Christi TX</div>
                </div>
                <div>
                    <div className="text-xl sm:text-3xl font-fredoka mb-2">
                        Get in Touch
                    </div>

                    {!isMobile ? (
                        <a
                            href="tel:+1234567890"
                            className=" text-gray-600 font-fredoka"
                        >
                            (361) 960-5501
                        </a>
                    ) : (
                        <div className="text-gray-600 font-fredoka">
                            (361) 960-5501
                        </div>
                    )}
                </div>

                <div className="absolute bottom-0 right-0 hidden md:block">
                    <img
                        style={{ height: "275px" }}
                        src="images/Cactus.png"
                        alt=""
                    />
                </div>
            </div>
            <div className="h-1/2 lg:h-full h-full lg:w-1/2">
                <Contact />
            </div>
        </div>
    );
}

export default ContactPage;
